// Generated file : do not modify
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Donnee pour calculer le lien de signature
export class ExternalRecipient {
  // 
  public id: string;
  // 
  public firstName: string;
  // 
  public lastName: string;
  // 
  public email: string;
  // 
  public phone: string;
  // 
  public company: string;
  // 
  public recipientType: number;
  // 
  public hidden: number;
  // 
  public apiId: string;
  // 
  public apiType: string;

  constructor() {
    this.id = '';
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.company = '';
    this.recipientType = 0;
    this.hidden = 0;
    this.apiId = '';
    this.apiType = '';
  }
}

export class ExternalRecipientResponse {
  // 
  public status: string;
  // 
  public result: ExternalRecipient;

  constructor() {
    this.status = '';
    this.result = new ExternalRecipient();
  }
}

export class EduSignDocumentFile {
  // 
  public name: string;
  // 
  public base64: string;

  constructor() {
    this.name = '';
    this.base64 = '';
  }
}

export class EduSignSignaturePosition {
  // 
  public page: string;
  // 
  public x: string;
  // 
  public y: string;
  // 
  public width: string;
  // 
  public height: string;

  constructor() {
    this.page = '';
    this.x = '';
    this.y = '';
    this.width = '';
    this.height = '';
  }
}

export class EduSignSignatureElement {
  // 
  public type: string;
  // 
  public position: EduSignSignaturePosition;

  constructor() {
    this.type = '';
    this.position = new EduSignSignaturePosition();
  }
}

export class EduSignSignatory {
  // 
  public type: string;
  // 
  public id: string;
  // 
  public elements: EduSignSignatureElement[];

  constructor() {
    this.type = '';
    this.id = '';
    this.elements = [];
  }
}

export class EduSignEmailReminder {
  // 
  public subject: string;
  // 
  public message: string;
  // 
  public amount: number;
  // 
  public interval: number;

  constructor() {
    this.subject = '';
    this.message = '';
    this.amount = 0;
    this.interval = 0;
  }
}

export class SendDocumentRequest {
  // 
  public userId: string;
  // 
  public adminId: string;
  // 
  public directoryId: string;
  // 
  public redirectionLinkOnceSigned: string;
  // 
  public document: EduSignDocumentFile;
  // 
  public sendDocumentToSignByEmail: boolean;
  // 
  public sendDocumentByEmailWhenCompleted: boolean;
  // 
  public inputs: EduSignDocumentInput[];
  // 
  public recipients: EduSignDocumentRecipient[][];
  // 
  public signatories: EduSignSignatory[];
  // 
  public emailReminder: EduSignEmailReminder;

  constructor() {
    this.userId = '';
    this.adminId = '';
    this.directoryId = '';
    this.redirectionLinkOnceSigned = '';
    this.document = new EduSignDocumentFile();
    this.sendDocumentToSignByEmail = false;
    this.sendDocumentByEmailWhenCompleted = false;
    this.inputs = [];
    this.recipients = [];
    this.signatories = [];
    this.emailReminder = new EduSignEmailReminder();
  }
}

export class EduSignDocumentInput {
  // 
  public category: string;
  // 
  public type: string;
  // 
  public index: number;
  // 
  public position: EduSignSignaturePosition;

  constructor() {
    this.category = '';
    this.type = '';
    this.index = 0;
    this.position = new EduSignSignaturePosition();
  }
}

export class EduSignDocumentRecipient {
  // 
  public category: string;
  // 
  public id: string;

  constructor() {
    this.category = '';
    this.id = '';
  }
}

export class SendDocumentResponse {
  // 
  public status: string;
  // 
  public documentsSuccess: number;
  // 
  public directoryId: string;
  // 
  public documents: string[];
  // 
  public documentsError: string[];

  constructor() {
    this.status = '';
    this.documentsSuccess = 0;
    this.directoryId = '';
    this.documents = [];
    this.documentsError = [];
  }
}

export class EduSignRecipient {
  // 
  public id: string;
  // 
  public token: string;
  // 
  public type: string;

  constructor() {
    this.id = '';
    this.token = '';
    this.type = '';
  }
}

export class EduSignDocumentVariables {
  // 
  public recipients: EduSignRecipient[];

  constructor() {
    this.recipients = [];
  }
}

export class EduSignDocumentResult {
  // 
  public variables: EduSignDocumentVariables;

  constructor() {
    this.variables = new EduSignDocumentVariables();
  }
}

export class EduSignDocumentResponse {
  // 
  public status: string;
  // 
  public result: EduSignDocumentResult;

  constructor() {
    this.status = '';
    this.result = new EduSignDocumentResult();
  }
}

export class SignatureLinkData {
  // 
  public documentId: string;
  // 
  public token: string;

  constructor() {
    this.documentId = '';
    this.token = '';
  }
}

export class ParticipantSignature {
  // 
  public type: string;
  // 
  public appId: string;
  // 
  public documentId: string;
  // 
  public participant: Participant;

  constructor() {
    this.type = '';
    this.appId = '';
    this.documentId = '';
    this.participant = new Participant();
  }
}

export class SignatureFinalised {
  // 
  public type: string;
  // 
  public appId: string;
  // 
  public documentId: string;
  // 
  public DOCUMENT_URL: string;
  // 
  public DOCUMENT_PROOF_URL: string;

  constructor() {
    this.type = '';
    this.appId = '';
    this.documentId = '';
    this.DOCUMENT_URL = '';
    this.DOCUMENT_PROOF_URL = '';
  }
}

export class Participant {
  // 
  public type: string;
  // 
  public id: string;

  constructor() {
    this.type = '';
    this.id = '';
  }
}

export default class EduSign  {

  public static webhookParticipantSignature (participantSignature: ParticipantSignature): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/edusigns/webhookParticipantSignature', participantSignature, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static webhookSignatureFinalised (signatureFinalised: SignatureFinalised): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/edusigns/webhookSignatureFinalised', signatureFinalised, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static signatureLink (documentId: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/edusigns/signatureLink/' + documentId, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static signatureLinkWithReconciliation (documentId: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/edusigns/signatureLinkWithReconciliation/' + documentId, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static edusignPolling (documentId: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/edusigns/edusignPolling/' + documentId, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(eduSigns: EduSign[]) {
  }
}
